import { ROUTE_NAMES } from './routeNames.const'

// TODO (JBO): refactor all of this, to much page for nothing
// A lot of page is just a duplication of another one

export const routesPatrimony = [
  {
    path: '/patrimoine',
    name: 'patrimony',
    component: () =>
      import(
        /* webpackChunkName: "Patrimony" */ 'src/pages/patrimony/Patrimony.vue'
      ),
    redirect: '/patrimoine/total',
    children: [
      {
        path: 'portfolio/:portfolioId',
        name: 'patrimonyPortfolio',
        component: () =>
          import(
            /* webpackChunkName: "Patrimony" */ 'src/pages/patrimony/PatrimonyPortfolio/PatrimonyPortfolio.vue'
          ),
        props: true,
        children: [
          {
            path: 'preview',
            name: ROUTE_NAMES.patrimony.portfolio.preview,
            component: () =>
              import(
                /* webpackChunkName: "Patrimony" */
                'src/pages/patrimony/PatrimonyPortfolio/tabs/PatrimonyPortfolioPreview/PatrimonyPortfolioPreview.vue'
              ),
            props: true,
          },
          {
            path: 'estimation',
            name: ROUTE_NAMES.patrimony.portfolio.estimation,
            component: () =>
              import(
                /* webpackChunkName: "Patrimony" */
                'src/pages/patrimony/PatrimonyPortfolio/tabs/PatrimonyPortfolioEstimation/PatrimonyPortfolioEstimation.vue'
              ),
            props: true,
          },
          {
            path: 'investments',
            name: ROUTE_NAMES.patrimony.portfolio.investments,
            component: () =>
              import(
                /* webpackChunkName: "Patrimony" */
                'src/pages/patrimony/PatrimonyPortfolio/tabs/PatrimonyPortfolioInvestments/PatrimonyPortfolioInvestments.vue'
              ),
            props: true,
          },
          {
            path: 'repartition',
            name: ROUTE_NAMES.patrimony.portfolio.repartition,
            component: () =>
              import(
                /* webpackChunkName: "Patrimony" */
                'src/pages/patrimony/PatrimonyPortfolio/tabs/PatrimonyPortfolioRepartition/PatrimonyPortfolioRepartition.vue'
              ),
          },
          {
            path: 'esg',
            name: ROUTE_NAMES.patrimony.portfolio.esg,
            component: () =>
              import(
                /* webpackChunkName: "Patrimony" */
                'src/pages/patrimony/PatrimonyPortfolio/tabs/PatrimonyPortfolioESG/PatrimonyPortfolioESG.vue'
              ),
          },
          {
            path: 'mon-contrat',
            name: ROUTE_NAMES.patrimony.portfolio.details,
            component: () =>
              import(
                /* webpackChunkName: "Patrimony" */ 'src/pages/patrimony/PatrimonyPortfolio/tabs/PatrimonyPortfolioDetails/PatrimonyPortfolioDetails.vue'
              ),
            props: true,
          },
        ],
      },
      {
        path: 'total',
        name: ROUTE_NAMES.patrimony.total,
        component: () => {
          return import(
            /* webpackChunkName: "Patrimony" */ `src/pages/patrimony/PatrimonyTotal/PatrimonyTotalV2.vue`
          )
        },
      },
      {
        path: 'aggregationManager',
        name: ROUTE_NAMES.patrimony.aggregationManager,
        component: () =>
          import(
            /* webpackChunkName: "Patrimony" */ 'src/pages/patrimony/PatrimonyAggregation/PatrimonyAggregationManager.vue'
          ),
      },
      {
        path: 'emprunts',
        name: ROUTE_NAMES.patrimony.loan,
        component: () => {
          return import(
            /* webpackChunkName: "Patrimony" */ `src/pages/patrimony/PatrimonyLoan/PatrimonyLoanV2.vue`
          )
        },
      },
    ],
  },
  {
    path: '/patrimoine/ajouter',
    name: ROUTE_NAMES.patrimony.add,
    component: () =>
      import(
        /* webpackChunkName: "Patrimony" */ 'src/pages/patrimony/PatrimonyAdd/PatrimonyAdd.vue'
      ),
  },
  {
    path: '/patrimoine/selection',
    name: ROUTE_NAMES.patrimony.aggregationSelection,
    component: () =>
      import(
        /* webpackChunkName: "Patrimony" */ 'src/pages/patrimony/PatrimonyAggregationMethodChoicePage/PatrimonyAggregationMethodChoicePage.vue'
      ),
  },
  {
    path: '/patrimoine/aggreger',
    name: ROUTE_NAMES.patrimony.aggregation,
    component: () =>
      import(
        'src/pages/patrimony/PatrimonyAggregation/PatrimonyAggregation.vue'
      ),
  },
  {
    path: '/patrimoine/estimate/:portfolioId?',
    name: ROUTE_NAMES.patrimony.estimation,
    component: () =>
      import(
        /* webpackChunkName: "Patrimony" */ 'src/pages/patrimony/PatrimonyEstimation/PatrimonyEstimation.vue'
      ),
  },
  {
    path: '/patrimoine/estimate-amount-selection',
    name: ROUTE_NAMES.patrimony.estimationAmount,
    component: () =>
      import(
        /* webpackChunkName: "Patrimony" */ 'src/pages/patrimony/PatrimonyEstimationAmount/PatrimonyEstimationAmountPage.vue'
      ),
  },
]
